export const USERNAME_STORAGE_KEY = "setback-username";

export function normalizeUsername(raw: string): string {
  return raw.trim().slice(0, 20);
}

export function loadStoredUsername(): string | null {
  const value = localStorage.getItem(USERNAME_STORAGE_KEY);
  if (!value) return null;
  const normalized = normalizeUsername(value);
  return normalized.length > 0 ? normalized : null;
}

export function saveStoredUsername(raw: string): string {
  const normalized = normalizeUsername(raw);
  localStorage.setItem(USERNAME_STORAGE_KEY, normalized);
  return normalized;
}
